<template>
  <vx-card title="Sliders">
    <p>Aquí se pueden modificar los Sliders que aparecen en el Home.</p>

    <div v-if="initProgress" style="margin-top: 1rem; width: 100%">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>

    <div class="mt-5">
      <!-- Sliders -->
      <div v-for="(slider, index) in content.sliders" :key="index">
        <div>
          <!-- Image Container -->
          <div class="img-container flex items-center justify-center">
            <img :src="slider.image" alt="img" class="responsive">

          </div>
          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" :id="`slider${index}`" @change="updateSlider($event,slider)"
                   accept="image/*">
            <span style="cursor: pointer" class="ml-2" type="flat"
                  @click="changeSlider(`slider${index}`)">Cambiar
                                </span>
            <span style="cursor: pointer" class="mr-2" type="flat" color="#999"
                  @click="deleteImage(index)">Eliminar</span>
          </div>
        </div>
        <div class="mt-5">
          <vs-input @blur="slider.path= trimString(slider.path)" label="Path" v-model="slider.path"
                    class="mt-5 w-full" name="path"
                    v-validate="'required'"/>
        </div>
        <hr class="mt-5 mb-5">
      </div>

      <!--Add image-->
      <vs-button style="width: 100%" @click="addSlider">Agregar slider (1360x 550)</vs-button>
      <!--End-->

      <div class="flex mt-6 flex-wrap items-center" slot="footer">
        <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Guardar</vs-button>
        <div v-if="progress" style="margin-top: 1rem; width: 100%">
          <vs-progress indeterminate color="primary"></vs-progress>
        </div>
      </div>

    </div>
  </vx-card>
</template>

<script>
import trimString from '../mixins/trimString'

import { db, auth, FieldValue } from '@/firebase/firebaseConfig'
import { uploadToCloudflare } from '@/services/cloudflareImages'

export default {
  name: 'Sliders',
  mixins: [
    trimString
  ],
  data () {
    return {
      content: {
        sliders: []
      },
      progress: false,
      initProgress: false
    }
  },
  /**
   * Get data on firestore
   * @returns {Promise<void>}
   */
  async created () {
    try {
      this.initProgress = true
      const querySnapshot = await db.collection('content').get()
      querySnapshot.forEach((doc) => {
        this.content.id = doc.id
        this.content.sliders = doc.data().sliders || []
      })
    } catch (e) {
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error.'
      })
    } finally {
      this.initProgress = false
    }
  },
  computed: {
    isFormValid () {
      return !this.errors.any()
    }
  },
  methods: {
    async submitData () {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          this.progress = true

          // Content
          let contentRef = db.collection('content').doc(this.content.id)

          //Clone to remove the id
          let cloneContent = Object.assign({}, this.content)
          delete cloneContent.id

          await contentRef.update({
            ...cloneContent,
            uid: auth.currentUser.uid,
            updatedAt: FieldValue.serverTimestamp()
          })

          this.$vs.notify({
            color: 'success',
            title: 'Sliders',
            text: 'Sliders modificados correctamente.'
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.progress = false
      }
    },
    async updateSlider (input, slider) {
      this.progress = true
      try {
        if (input.target.files && input.target.files[0]) {
          slider.image = await this.submitImages(input.target.files[0])
        }
      } catch (e) {
        console.error('Error subiendo slider:', e)
        this.$vs.notify({
          color: 'danger',
          title: 'Error al subir imagen',
          text: e.message || 'No se pudo subir la imagen. Revisa la consola.'
        })
      } finally {
        this.progress = false
      }
    },
    deleteImage (index) {
      this.content.sliders.splice(index, 1)
    },
    async submitImages (image) {
      return await uploadToCloudflare(image, '1360x550')
    },
    changeSlider (id) {
      const slider = document.getElementById(id)
      slider.click()
    },
    addSlider () {
      let obj = {
        path: '/',
        image: 'https://via.placeholder.com/1366x550'
      }
      this.content.sliders.push(obj)
    }
  }
}
</script>
